import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    rootLandSearchProgramCardBody: {
        width: '100%',
        height: '100%',
        background: props => `url(${props.backgroundImage})`,
        backgroundSize: "cover !important",
        // imageRendering: '-webkit-optimize-contrast',
        backgroundPosition: 'center !important',
        border: `0.5px solid ${theme.palette.colors.fillStroke[100]}`,
        borderRadius: '8px',
        [theme.breakpoints.down('xs')]: {
            border: 'none',
        }
    },
}));